import { Container, styled } from '@mui/material';

export const SignInFormContainer = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '20px',
  width: '100%',
});
